export default __webpack_public_path__ + "static/media/12.a27e7a4f.jpg";